<template>
  <div
    :class="[$style.bg, { [$style.bgClosing]: isClosing }]"
    @click.self="startClose"
  >
    <div
      :class="[
        $style.panel,
        { [$style.closing]: isClosing },
        { [$style.indent]: isMobile },
      ]"
    >
      <div :class="$style.contentScroll">
        <div v-if="showCategoryFilter" :class="$style.section">
          <div :class="$style.sectionHeader">
            <span :class="$style.sectionTitle">ПОЛ</span>
          </div>
          <div :class="$style.brandList">
            <div
              v-for="opt in categoryOptions"
              :key="opt.value"
              :class="$style.brandRow"
              @click="toggleCategory(opt.value)"
            >
              <span>{{ opt.label }}</span>
              <div
                :class="[
                  $style.circle,
                  {
                    [$style.activeCircle]: (
                      localFilters.category || []
                    ).includes(opt.value),
                  },
                ]"
              >
                <img
                  v-if="(localFilters.category || []).includes(opt.value)"
                  src="@/assets/img/market/check.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <!-- BRAND -->
        <div v-if="showBrandFilters" :class="$style.section">
          <div :class="$style.sectionHeader">
            <span :class="$style.sectionTitle">БРЕНД</span>
            <button :class="$style.sectionAction" @click="openBrandsSection">
              ВСЕ
              <svg
                width="9"
                height="12"
                viewBox="0 0 9 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.27166 5.93359C8.27166 6.02018 8.25346 6.10221 8.21696 6.17969C8.18506 6.2526 8.13726 6.32096 8.07346 6.38477L2.65936 11.6826C2.53626 11.8057 2.38596 11.8672 2.20816 11.8672C2.09426 11.8672 1.98946 11.8398 1.89376 11.7852C1.79806 11.7305 1.72286 11.6553 1.66816 11.5596C1.61346 11.4684 1.58606 11.3636 1.58606 11.2451C1.58606 11.0765 1.64536 10.9284 1.76386 10.8008L6.74036 5.93359L1.76386 1.06641C1.64536 0.938802 1.58606 0.79069 1.58606 0.62207C1.58606 0.503581 1.61346 0.398763 1.66816 0.307617C1.72286 0.211914 1.79806 0.136719 1.89376 0.0820312C1.98946 0.0273438 2.09426 0 2.20816 0C2.38596 0 2.53626 0.0592448 2.65936 0.177734L8.07346 5.48242C8.13726 5.54622 8.18506 5.61686 8.21696 5.69434C8.25346 5.76725 8.27166 5.84701 8.27166 5.93359Z"
                  fill="#EC6608"
                />
              </svg>
            </button>
          </div>

          <div :class="$style.brandList">
            <!-- КНОПКА "Выбрать все" -->
            <div :class="$style.brandAllRow" @click="selectAllBrands">
              <span :class="$style.brandAllText">Выбрать все</span>
            </div>

            <!-- Список брендов -->
            <div
              v-for="b in brands"
              :key="b"
              :class="$style.brandRow"
              @click="toggleBrand(b)"
            >
              <span>{{ b }}</span>

              <div
                :class="[
                  $style.circle,
                  { [$style.activeCircle]: localFilters.brand.includes(b) },
                ]"
              >
                <img
                  v-if="localFilters.brand.includes(b)"
                  src="@/assets/img/market/check.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <!-- COLOR -->
        <div :class="$style.section">
          <div :class="$style.sectionHeader">
            <span :class="$style.sectionTitle">ЦВЕТ</span>
          </div>

          <div :class="$style.colorRow">
            <div
              v-for="c in colors"
              :key="c"
              :class="$style.colorItem"
              @click="toggleColor(c)"
            >
              <div
                :style="{ background: colorMap[c] }"
                :class="[
                  $style.colorDot,
                  { [$style.colorActive]: localFilters.color.includes(c) },
                  {
                    [$style.colorLight]:
                      localFilters.color.includes(c) && lightColors.includes(c),
                  },
                ]"
              >
                <div
                  v-if="localFilters.color.includes(c)"
                  :class="$style.check"
                >
                  <img src="@/assets/img/market/check.svg" alt="" />
                </div>
              </div>
              <span :class="$style.colorLabel">{{ colorLabels[c] || translateColor(c) }}</span>
            </div>
          </div>
        </div>

        <!-- SIZE -->
        <div :class="$style.section">
          <div :class="$style.sectionHeader">
            <span :class="$style.sectionTitle">РАЗМЕР</span>
          </div>

          <div :class="$style.sizeTabs">
            <button
              v-for="t in sizeTypeOptions"
              :key="t.value"
              :class="[
                $style.sizeTab,
                localFilters.size_type === t.value && $style.sizeTabActive,
              ]"
              @click="setSizeType(t.value)"
            >
              {{ t.label }}
            </button>
          </div>

          <div :class="$style.sizeScrollWrap">
            <DragScroll
              ref="sizeDrag"
              :className="$style.sizeScrollArea"
              :interactive="true"
            >
              <button
                v-for="size in sizeOptions"
                :key="String(size)"
                :class="[
                  $style.sizeCell,
                  isSizeSelected(size) && $style.sizeCellSelected,
                ]"
                @click="toggleSize(size)"
              >
                {{ formatSizeValue(size) }}
              </button>
            </DragScroll>
            <div
              v-if="sizeScrollable && !sizeAtEnd"
              :class="$style.sizeScrollFade"
              aria-hidden="true"
            ></div>
            <button
              v-if="sizeScrollable && !sizeAtEnd"
              :class="$style.sizeScrollHint"
              type="button"
              aria-label="Прокрутить размеры"
              @click.stop="scrollSizesRight"
            >
              ›
            </button>
          </div>
        </div>

        <!-- ATTRIBUTES (характеристики моделей) -->
        <div :class="$style.section">
          <div :class="$style.sectionHeader">
            <span :class="$style.sectionTitle">ТИП</span>
          </div>

          <div
            v-for="group in attributeGroups"
            :key="group.key"
            :class="$style.attrGroup"
          >
            <button
              type="button"
              :class="$style.attrGroupHeader"
              :aria-expanded="isOpenAttrGroup(group.key)"
              @click="toggleAttrGroup(group.key)"
            >
              <span :class="$style.attrGroupLabel">{{ group.label }}</span>
              <span
                v-if="selectedAttrCount(group.key)"
                :class="$style.attrCount"
              >
                {{ selectedAttrCount(group.key) }}
              </span>
              <span
                :class="[
                  $style.attrArrow,
                  isOpenAttrGroup(group.key) && $style.attrArrowOpen,
                ]"
                aria-hidden="true"
                >›</span
              >
            </button>
            <div v-if="isOpenAttrGroup(group.key)" :class="$style.attrOptions">
              <button
                v-for="v in group.values"
                :key="v"
                type="button"
                :class="[
                  $style.attrOption,
                  isAttrSelected(group.key, v) && $style.attrOptionSelected,
                ]"
                @click="toggleAttrValue(group.key, v)"
              >
                <span :class="$style.attrBox" aria-hidden="true"></span>
                <span :class="$style.attrOptionLabel">{{ v }}</span>
              </button>
            </div>
          </div>
        </div>

        <!-- CUSTOM -->
        <div :class="$style.section">
          <div :class="$style.sectionHeader">
            <span :class="$style.sectionTitle">КАСТОМНЫЕ</span>
          </div>

          <div :class="$style.sizeRow">
            <button
              :class="[
                $style.sizeBtn,
                { [$style.activeSize]: localFilters.custom === true },
              ]"
              @click="
                localFilters.custom = localFilters.custom === true ? null : true
              "
            >
              Да
            </button>
            <button
              :class="[
                $style.sizeBtn,
                { [$style.activeSize]: localFilters.custom === false },
              ]"
              @click="
                localFilters.custom =
                  localFilters.custom === false ? null : false
              "
            >
              Нет
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Buttons -->
    <div :class="[$style.bottomBar, { [$style.indent]: isMobile }]">
      <button :class="$style.clearBtn" @click="reset">Очистить</button>
      <button :class="$style.applyBtn" @click="apply">Применить</button>
    </div>
  </div>
</template>

<script>
import { SIZE_CHART, convertSize } from "@/utils/sizeChart.js"
import { translateColor } from "@/utils/colorTranslate.js"
import DragScroll from "@/components/DragScroll.vue"

// Группы характеристик моделей (справочник по референсу fwjenf.ru).
// Ключи совпадают с параметрами бэкенда (market.py, ATTRIBUTE_FILTER_KEYS)
// и ключами product_models.attributes.
const ATTRIBUTE_GROUPS = [
  {
    key: "height",
    label: "Высота",
    values: ["высокие", "средние", "низкие"],
  },
  {
    key: "sport",
    label: "Спорт",
    values: [
      "баскетбол", "бег", "волейбол", "скейтбординг", "теннис",
      "тренировки", "туризм", "футбол", "ходьба",
    ],
  },
  {
    key: "tech",
    label: "Технологии",
    values: [
      "abzorb", "air", "boost", "bounce", "climacool", "climawarm",
      "continental", "dmx", "encap", "ff blast", "flight", "floatride",
      "flyknit", "flytefoam", "formula 23", "fresh foam", "fuelcell", "gel",
      "gore-tex", "hexalite", "hybrid", "ignite", "lightstrike", "n-ergy",
      "nitro", "primeblue", "primegreen", "primeknit", "react", "revlite",
      "shox", "traxion", "trusstic", "zig", "zoom",
    ],
  },
  {
    key: "season",
    label: "Сезон",
    values: ["всесезонные", "зима", "весна", "осень", "лето"],
  },
  {
    key: "closure",
    label: "Застёжка",
    values: ["шнуровка", "липучка", "молния", "пряжка", "эластичная лента"],
  },
  {
    key: "material",
    label: "Материалы",
    values: [
      "кожа", "искусственная кожа", "замша", "текстиль", "сетка",
      "полиуретан", "полиэстер", "резина",
    ],
  },
  {
    key: "style",
    label: "Стиль",
    values: ["спортивный", "уличный", "минималистичный", "модный", "ретро"],
  },
]

export default {
  name: "FiltersModal",
  components: { DragScroll },

  emits: ["apply", "close", "open-brands"],

  props: {
    filters: Object,
    useGlobalBackHandler: {
      type: Boolean,
      default: false,
    },
    showBrandFilters: {
      type: Boolean,
      default: true,
    },
    showCategoryFilter: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    // Нормализация входных фильтров: цвет может прийти одиночным значением
    // (старая форма) — приводим к массиву; пустая размерная сетка — дефолт EU,
    // чтобы таб EU был выделен сразу.
    const incoming = JSON.parse(JSON.stringify(this.filters)) || {}
    const localFilters = {
      brand: [],
      color: [],
      size: [],
      size_type: "EU",
      custom: null,
      category: [],
      ...incoming,
    }
    if (!Array.isArray(localFilters.color)) {
      localFilters.color = localFilters.color ? [localFilters.color] : []
    }
    if (!Array.isArray(localFilters.size)) {
      localFilters.size =
        localFilters.size !== null && localFilters.size !== undefined
          ? [localFilters.size]
          : []
    }
    if (!localFilters.size_type) {
      localFilters.size_type = "EU"
    }
    // Характеристики (attrs): словарь группа → массив выбранных значений
    const attrs = {}
    for (const g of ATTRIBUTE_GROUPS) {
      const sel = (incoming.attrs || {})[g.key]
      attrs[g.key] = Array.isArray(sel) ? sel.filter(Boolean) : []
    }
    localFilters.attrs = attrs

    return {
      localFilters,
      attributeGroups: ATTRIBUTE_GROUPS,
      openAttrGroups: {},
      sizeScrollable: false,
      sizeAtEnd: false,
      categoryOptions: [
        { value: "MALE", label: "Мужские" },
        { value: "FEMALE", label: "Женские" },
        { value: "UNISEX", label: "Унисекс" },
      ],

      brands: [
        "Nike",
        "Jordan",
        "Adidas",
        "Adidas Originals",
        "Yeezy",
        "New Balance",
        "Reebok",
        "Puma",
        "ASICS",
        "Vans",
        "Balenciaga",
        "Premiata",
        "Saucony",
        "Converse",
        "Supreme",
        "Bape",
        "Chrome Hearts",
        "Solomon",
        "Off White",
        "Kith",
      ],
      // 12 цветов заказчика, в заданном порядке; ключи — группы,
      // которые матчятся с БД на бэкенде (COLOR_FILTER_PATTERNS в market.py)
      colors: [
        "white",
        "black",
        "gray",
        "beige",
        "yellow",
        "red",
        "pink",
        "purple",
        "blue",
        "green",
        "brown",
        "multicolour",
      ],
      colorLabels: {
        white: "Белый",
        black: "Черный",
        gray: "Серый",
        beige: "Бежевый",
        yellow: "Желтый",
        red: "Красный",
        pink: "Розовый",
        purple: "Фиолетовый",
        blue: "Синий",
        green: "Зеленый",
        brown: "Коричневый",
        multicolour: "Разноцветный",
      },
      // Мягкая палитра точек (вместо резких чистых цветов);
      // разноцветный — радужный градиент
      colorMap: {
        white: "#FFFFFF",
        black: "#161616",
        gray: "#9AA0A6",
        beige: "#E8D3B0",
        yellow: "#F7C948",
        red: "#E5484D",
        pink: "#F06FAE",
        purple: "#9B6BDF",
        blue: "#4A90E2",
        green: "#3DA35D",
        brown: "#9C6644",
        multicolour:
          "linear-gradient(135deg, #FF5B5B 0%, #FFB84D 18%, #FFE14D 34%, " +
          "#6FD66F 50%, #4DA3FF 66%, #7B61FF 82%, #C46BFF 100%)",
      },
      isClosing: false,
      backBtn: null,

      isMobile: false,
    }
  },
  computed: {
    lightColors() {
      return ["white", "beige", "yellow", "pink"]
    },
    sizeTypeOptions() {
      return [
        { value: "EU", label: "EU" },
        { value: "RU", label: "RU" },
        { value: "US", label: "US" },
        { value: "UK", label: "UK" },
        { value: "CM", label: "CM" },
      ]
    },
    sizeOptions() {
      const type = String(this.localFilters.size_type || "EU").toUpperCase()
      const key = type === "CM" ? "cm" : type.toLowerCase()

      const values = (SIZE_CHART || [])
        .map((row) => row?.[key])
        .filter((v) => v !== null && v !== undefined)

      const seen = new Set()
      const unique = []
      values.forEach((v) => {
        const k = String(v)
        if (seen.has(k)) return
        seen.add(k)
        unique.push(v)
      })

      const numeric = unique
        .map((v) => ({ raw: v, n: this.parseNumeric(v) }))
        .filter((x) => x.n !== null)
        .sort((a, b) => a.n - b.n)
        .map((x) => x.raw)

      return numeric.length ? numeric : unique
    },
  },
  mounted() {
    // Устанавливаем состояние открытия фильтров в store
    this.$store.commit("setFiltersModalOpen", true)

    if (!this.useGlobalBackHandler && window.Telegram?.WebApp?.BackButton) {
      this.backBtn = window.Telegram.WebApp.BackButton
      this.backBtn.show()
      this.backBtn.onClick(this.startClose)
    }

    if (window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp
      tg.ready()

      if (tg.platform === "ios" || tg.platform === "android") {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    }

    // Предотвращаем блокировку скролла
    this.$nextTick(() => {
      const contentScroll = this.$el?.querySelector(
        `.${this.$style.contentScroll}`
      )
      if (contentScroll) {
        // Убеждаемся, что скролл работает
        contentScroll.style.overflowY = "auto"
        contentScroll.style.webkitOverflowScrolling = "touch"
      }
    })

    // Индикатор прокрутки ряда размеров
    this.$nextTick(() => {
      const el = this.getSizeScrollEl()
      if (el) {
        el.addEventListener("scroll", this.onSizeScroll, { passive: true })
      }
      this.updateSizeScrollState()
    })
  },

  beforeUnmount() {
    // Сбрасываем состояние открытия фильтров в store
    this.$store.commit("setFiltersModalOpen", false)

    const sizeEl = this.getSizeScrollEl()
    if (sizeEl) {
      sizeEl.removeEventListener("scroll", this.onSizeScroll)
    }

    if (this.backBtn) {
      this.backBtn.offClick(this.startClose)
      this.backBtn.hide()
    }
  },

  methods: {
    startClose() {
      if (this.isClosing) return
      this.isClosing = true

      // Сбрасываем состояние открытия фильтров в store
      this.$store.commit("setFiltersModalOpen", false)

      if (this.backBtn) this.backBtn.hide()

      setTimeout(() => {
        this.$emit("close")
      }, 280)
    },

    reset() {
      this.localFilters = {
        brand: [],
        color: [],
        size: [],
        size_type: "EU",
        custom: null,
        category: [],
        attrs: Object.fromEntries(
          ATTRIBUTE_GROUPS.map((g) => [g.key, []])
        ),
      }
      this.openAttrGroups = {}
      this.$nextTick(this.updateSizeScrollState)
    },

    apply() {
      const filtersToApply = { ...this.localFilters }

      // На фронте размеры можно выбрать в любой системе (мультивыбор),
      // но на сервер отправляем только EU, без дублей.
      const selectedType = String(
        filtersToApply.size_type || "EU"
      ).toUpperCase()
      const euList = []
      for (const s of filtersToApply.size || []) {
        const eu = convertSize(s, selectedType, "EU")
        if (eu !== null && !euList.includes(String(eu))) {
          euList.push(String(eu))
        }
      }
      filtersToApply.size = euList
      filtersToApply.size_type = euList.length ? "EU" : null

      // Характеристики: наверх отдаём только непустые группы
      const attrs = {}
      for (const g of ATTRIBUTE_GROUPS) {
        const sel = (this.localFilters.attrs || {})[g.key] || []
        if (sel.length > 0) {
          attrs[g.key] = [...sel]
        }
      }
      filtersToApply.attrs = attrs

      this.$emit("apply", filtersToApply)
      if (this.backBtn) this.backBtn.hide()
    },

    toggleBrand(b) {
      if (this.localFilters.brand.includes(b)) {
        this.localFilters.brand = this.localFilters.brand.filter((i) => i !== b)
      } else {
        this.localFilters.brand.push(b)
      }
    },

    selectAllBrands() {
      this.localFilters.brand = [...this.brands]
    },
    toggleCategory(value) {
      const arr = this.localFilters.category || []
      const idx = arr.indexOf(value)
      if (idx === -1) {
        this.localFilters.category = [...arr, value]
      } else {
        this.localFilters.category = arr.filter((v) => v !== value)
      }
    },
    openBrandsSection() {
      this.$emit("open-brands")
    },
    toggleColor(c) {
      // Мультивыбор цветов (на сервер уходит список)
      this.localFilters.color = this.localFilters.color.includes(c)
        ? this.localFilters.color.filter((x) => x !== c)
        : [...this.localFilters.color, c]
    },
    toggleSize(size) {
      // Мультивыбор размеров: добавляем/убираем из списка
      if (this.isSizeSelected(size)) {
        this.localFilters.size = this.localFilters.size.filter(
          (s) => !this.isSameSize(s, size)
        )
      } else {
        this.localFilters.size = [...this.localFilters.size, size]
      }
    },

    setSizeType(type) {
      const nextType = String(type || "EU").toUpperCase()
      const prevType = String(this.localFilters.size_type || "EU").toUpperCase()
      if (nextType === prevType) return

      // Пытаемся сохранить выбранные размеры при переключении типа сетки
      if ((this.localFilters.size || []).length > 0) {
        const converted = []
        for (const s of this.localFilters.size) {
          const c = convertSize(s, prevType, nextType)
          if (
            c !== null &&
            !converted.some((x) => this.isSameSize(x, c))
          ) {
            converted.push(c)
          }
        }
        this.localFilters.size = converted
      }

      this.localFilters.size_type = nextType
      // Сетка сменилась — пересчитать индикатор прокрутки
      this.$nextTick(this.updateSizeScrollState)
    },

    parseNumeric(value) {
      const normalized = String(value ?? "")
        .trim()
        .replace(",", ".")
        .replace(/\s+/g, "")
      const num = Number(normalized)
      return Number.isFinite(num) ? num : null
    },

    isSameSize(a, b) {
      return String(a ?? "") === String(b ?? "")
    },

    isSizeSelected(size) {
      return (this.localFilters.size || []).some((s) =>
        this.isSameSize(s, size)
      )
    },

    formatSizeValue(value) {
      if (value === null || value === undefined) return ""
      return String(value).replace(".", ",")
    },
    translateColor(color) {
      return translateColor(color)
    },

    // ── Индикатор «скроллится вправо» у ряда размеров ──
    getSizeScrollEl() {
      return this.$refs.sizeDrag?.$refs?.container || null
    },
    updateSizeScrollState() {
      const el = this.getSizeScrollEl()
      if (!el) {
        this.sizeScrollable = false
        this.sizeAtEnd = false
        return
      }
      this.sizeScrollable = el.scrollWidth - el.clientWidth > 8
      this.sizeAtEnd =
        el.scrollLeft + el.clientWidth >= el.scrollWidth - 8
    },
    scrollSizesRight() {
      const el = this.getSizeScrollEl()
      if (!el) return
      el.scrollBy({ left: el.clientWidth * 0.8, behavior: "smooth" })
    },
    onSizeScroll() {
      this.updateSizeScrollState()
    },

    // ── Характеристики (attrs) ──
    toggleAttrGroup(key) {
      this.openAttrGroups = {
        ...this.openAttrGroups,
        [key]: !this.openAttrGroups[key],
      }
    },
    isOpenAttrGroup(key) {
      return Boolean(this.openAttrGroups[key])
    },
    isAttrSelected(key, value) {
      return ((this.localFilters.attrs || {})[key] || []).includes(value)
    },
    selectedAttrCount(key) {
      return ((this.localFilters.attrs || {})[key] || []).length
    },
    toggleAttrValue(key, value) {
      const cur = (this.localFilters.attrs || {})[key] || []
      this.localFilters = {
        ...this.localFilters,
        attrs: {
          ...this.localFilters.attrs,
          [key]: cur.includes(value)
            ? cur.filter((v) => v !== value)
            : [...cur, value],
        },
      }
    },
  },
}
</script>

<style lang="scss" module>
/* ===== BACKDROP ===== */
@keyframes fadeInBg {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(10px);
  }
}
@keyframes fadeOutBg {
  from {
    opacity: 1;
    backdrop-filter: blur(10px);
  }
  to {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
}

.bg {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(10px);
  z-index: 200;
  display: flex;
  justify-content: flex-end;
  animation: fadeInBg 0.28s ease forwards;
}

.bgClosing {
  animation: fadeOutBg 0.28s ease forwards !important;
}

/* ===== PANEL ===== */

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slideOut {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

.panel {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 4rem 0 0 0;
  transform: translateX(100%);
  animation: slideIn 0.28s ease forwards;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  touch-action: pan-y;
  &.indent {
    padding: 7rem 0 0 0;
  }
}

.contentScroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 1rem;
  padding-bottom: 14rem;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  overscroll-behavior: contain;
  will-change: scroll-position;
}

.closing {
  animation: slideOut 0.28s ease forwards !important;
}

/* ===== SECTION ===== */

.section {
  margin-bottom: 1rem;
}

.sectionHeader {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.sectionTitle {
  font-size: 0.875rem;
  color: #777;
}

.sectionAction {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: #ec6608;
  background: none;
  border: none;
  svg {
    width: 0.625rem;
    height: 0.75rem;
    margin-left: 0.25rem;
  }
}

/* ===== BRAND LIST ===== */

.brandList {
  background: #f8f9fb;
  border-radius: 0.625rem;
  overflow: hidden;
}

.brandAllRow {
  position: relative;
  padding: 0.75rem 1rem;
}

.brandAllRow::after {
  content: "";
  position: absolute;
  left: 1rem;
  right: 0;
  bottom: 0;
  height: 1px;
  background: #dfe0e4;
}

.brandAllText {
  color: #ec6608;
  font-size: 1rem;
  font-weight: 400;
}

.brandRow {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  font-size: 1rem;
}

/* Псевдолиния под брендом */
.brandRow::after {
  content: "";
  position: absolute;
  left: 1rem; /* тот же отступ, что у текста */
  right: 0; /* тянется до правого края */
  bottom: 0;
  height: 1px;
  background: #dfe0e4;
}

.brandRow:last-child::after {
  display: none;
}

.circle {
  position: relative;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  border: 1px solid #ccc;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.activeCircle {
  background: #ec6608;
  border-color: #ec6608;
}

/* ===== COLORS ===== */

/* Цвета: круг и подпись в одну строку, сетка в 3 колонки */
.colorRow {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.6rem 0.25rem;
}

.colorItem {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  min-width: 0;
}

.colorLabel {
  font-size: 0.75rem;
  line-height: 1.15;
  color: #161616;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.colorDot {
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 50%;
  position: relative;
  border: 1px solid rgb(156, 156, 156);
}

.colorActive {
  border-color: #f07818;
}

.check {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0.625rem;
  height: 0.625rem;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    filter: brightness(0) invert(1);
  }
}

.colorLight .check {
  img {
    filter: brightness(0);
  }
}

/* ===== SIZE ===== */

.sizeRow {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.sizeBtn {
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  background: #f5f7fa;
  color: #000000;
  border: none;
  font-size: 0.875rem;
}

.activeSize {
  background: #ec6608;
  color: #fff;
}

/* SIZE (like Market/Product.vue) */
.sizeTabs {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #9b9b9b;
  position: relative;
}

.sizeTab {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 0.875rem;
  padding: 0.5rem 0;
  text-align: center;
  color: #0a0a0a;
  cursor: pointer;
  position: relative;
  font-weight: 300;
}

.sizeTabActive {
  color: #0a0a0a;
  font-weight: 600;
}

.sizeTabActive::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 2px;
  background: #0a0a0a;
  border-radius: 0.25rem;
}

.sizeScrollWrap {
  position: relative;
}

.sizeScrollArea {
  display: flex;
  gap: 0.25rem;
  overflow-x: auto;
  padding: 0.5rem 0;
  scrollbar-width: none;
}

.sizeScrollArea::-webkit-scrollbar {
  display: none;
}

/* Затухание и шеврон справа — подсказка, что ряд прокручивается */
.sizeScrollFade {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 2.5rem;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.9) 55%,
    #ffffff
  );
  pointer-events: none;
}

.sizeScrollHint {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1.5rem;
  height: 2rem;
  border: none;
  background: transparent;
  color: #0a0a0a;
  font-size: 1.5rem;
  line-height: 1;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  z-index: 2;
}

.sizeCell {
  border: none;
  background: transparent;
  font-size: 0.875rem;
  font-weight: 300;
  color: #0a0a0a;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  transition: background 0.2s, color 0.2s;
}

.sizeCellSelected {
  background: #f5f7fa;
  font-weight: 600;
}

/* ===== ATTRIBUTES (характеристики) ===== */
.attrGroup {
  border-bottom: 1px solid #f0f0f2;
}

.attrGroup:last-child {
  border-bottom: none;
}

.attrGroupHeader {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.attrGroupLabel {
  font-size: 0.875rem;
  font-weight: 600;
  color: #161616;
  flex: 1;
  text-align: left;
}

.attrCount {
  min-width: 1.125rem;
  height: 1.125rem;
  padding: 0 0.25rem;
  border-radius: 0.5625rem;
  background: #ec6608;
  color: #ffffff;
  font-size: 0.6875rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.attrArrow {
  font-size: 1.25rem;
  line-height: 1;
  color: #9b9ba1;
  transform: rotate(0deg);
  transition: transform 0.15s ease;
}

.attrArrowOpen {
  transform: rotate(90deg);
}

.attrOptions {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.375rem;
  padding: 0 0 0.75rem 0;
}

.attrOption {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.5rem;
  border: 1px solid #f0f0f2;
  border-radius: 0.5rem;
  background: #ffffff;
  cursor: pointer;
  min-width: 0;
}

.attrOptionSelected {
  border-color: #ec6608;
  background: #fef6f0;
}

.attrBox {
  width: 0.875rem;
  height: 0.875rem;
  min-width: 0.875rem;
  border: 1.5px solid #c9c9ce;
  border-radius: 0.25rem;
  background: #ffffff;
}

.attrOptionSelected .attrBox {
  border-color: #ec6608;
  background: #ec6608;
  position: relative;
}

.attrOptionSelected .attrBox::after {
  content: "";
  position: absolute;
  left: 0.21rem;
  top: 0.1rem;
  width: 0.25rem;
  height: 0.45rem;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.attrOptionLabel {
  font-size: 0.75rem;
  color: #161616;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ===== BOTTOM BAR ===== */

.bottomBar {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: auto !important;
  padding: 0.5rem 1rem !important;
  padding-bottom: calc(0.5rem + env(safe-area-inset-bottom)) !important;
  background: #ebeaea !important;
  display: flex !important;
  align-items: center;
  gap: 0.625rem;
  z-index: 10001 !important;
  visibility: visible !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  &.indent {
    padding: 0.5rem 1rem 1rem 1rem !important;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom)) !important;
  }
}

.clearBtn {
  flex: 1;
  min-height: 3.125rem;
  height: 3.125rem;
  border-radius: 0.625rem;
  background: #a41b1b0d;
  border: none;
  color: #ff3b30;
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.applyBtn {
  flex: 1;
  min-height: 3.125rem;
  height: 3.125rem;
  border-radius: 0.625rem;
  background: #ec6608;
  border: none;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
